//腾讯云
import COS from "cos-js-sdk-v5";
export default {
  //显示loading
  showLoading(txt) {
    if (!window.loading) {
      window.loading = window.$VUE.$loading({
        lock: true,
        text: txt ? txt : window.$VUE.$t("请稍候"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
      });
    }
  },
  //隐藏loading
  hideLoading() {
    window.loading && window.loading.close();
    window.loading = "";
  },
  //错误提示
  error(text) {
    this.hideLoading();
    window.$VUE.$message.error(text);
  },
  //提示消息
  message(text, type = "warning") {
    this.hideLoading();
    window.$VUE.$message({
      message: text,
      customClass: `dreamrail-message dreamrail-message-${type}`,
      iconClass: "dreamrail-message-icon",
    });
  },

  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  },
  invoke(name, data = {}, sync = true) {
    console.log("invoke", name, data);
    // if (window.$VUE.$route.path !== "/identity" && window.$VUE.$store.state.user.login && (window.$VUE.$store.state.user.nickname === undefined || window.$VUE.$store.state.user._attribute.phone === undefined)) {
    const isHomePage = window.$VUE.$route.path === "/";
    const isTemporaryUser = window.$VUE.$store.state.user.isTemporaryUser;
    if (window.$VUE.$route.path !== "/identity" && window.$VUE.$store.state.user.login && window.$VUE.$store.state.user.nickname === undefined && !(isHomePage && isTemporaryUser)) {
      window.$VUE.$router.replace("/identity");
      return Promise.reject(new Error("用户信息不完整，请先完善个人信息"));
    }
    return window.$VUE.$BaaS.invoke(name, data, sync).catch((err) => {
      console.dir(err);
      if (err.code == 403) {
        localStorage.beforeLogin = encodeURIComponent(window.location.href); //记录登录前的地址
        window.$VUE.$method.message(window.$VUE.$t("请登录"));
        window.$VUE.$router.push("/login");
      }
      if (err.code == 400) {
      }
    });
  },
  delUrlParam(param) {
    let url = new window.URL(window.location.href);
    url.searchParams.delete(param);
    window.history.replaceState({}, "", url.toString());
    return url.href;
  },
  //增加url中的参数
  addUrlParam(key, value) {
    let url = new window.URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.replaceState({}, "", url.toString());
    return url.href;
  },
  formatMilliseconds(ms) {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    const remainingHours = hours % 24;
    const remainingMinutes = minutes % 60;
    const remainingSeconds = seconds % 60;

    const parts = [];

    if (days > 0) {
      parts.push(`${days}天`);
    }
    if (remainingHours > 0) {
      parts.push(`${remainingHours}小时`);
    }
    if (remainingMinutes > 0) {
      parts.push(`${remainingMinutes}分钟`);
    }
    if (remainingSeconds > 0 || parts.length === 0) {
      // 确保至少显示秒数为0的情况
      parts.push(`${remainingSeconds}秒`);
    }

    return parts.join(" ");
  },
  isMobile() {
    // 获取用户的浏览器信息
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 判断是否包含移动设备的关键字
    return /android|iphone|ipad|ipod|windows phone|mobile/i.test(userAgent);
  },
  //微信登录检查机制
  loginWithWechat() {
    window.$VUE.$BaaS.auth
      .getCurrentUser()
      .then((user) => {
        // 如果是临时用户，不执行任何登录后续逻辑
        if (user._anonymous) {
          console.log("临时用户，不执行登录后续逻辑");
          return;
        }
        // user 为 currentUser 对象
        console.log("检查用户是否登录", user);
        window.$VUE.$store.commit(
          "setUser",
          Object.assign({}, window.$VUE.$store.state.user, user, {
            login: true,
          })
        );
        console.log(user._attribute.phone, user.nickname);
        if (/MicroMessenger/i.test(window.navigator.userAgent) && !sessionStorage.wechatLogin) {
          //从微信里面打开那么用户必须授权登录
          window.$VUE.$BaaS.auth
            .getRedirectResult()
            .then((result) => {
              // 获取授权结果成功，可以在这里做登录后的操作
              console.log("授权登录成功", result);
              sessionStorage.wechatLogin = true;

              // if (user._attribute.phone === undefined || user.nickname === undefined) {
              if (user.nickname === undefined) {
                window.$VUE.$router.replace("/identity");
              }
              window.$VUE.$BaaS.invoke("addMileage", { rule: 2025062301 });
            })
            .catch((err) => {
              // 未获取到结果
              console.log("授权登录失败", err);
              user.linkThirdParty("oauth-wechat-mp", "/wechatAuth.html", {
                mode: "redirect",
              });
            });
        } else {
          // if (user._attribute.phone === undefined || user.nickname === undefined) {
          if (user.nickname === undefined) {
            window.$VUE.$router.replace("/identity");
          }
          window.$VUE.$BaaS.invoke("addMileage", { rule: 2025062301 });
        }
      })
      .catch((err) => {
        // HError
        if (err.code === 604) {
          console.log("用户未登录");
          window.$VUE.$store.commit("setUser", {
            login: false,
          });
        }
      });
  },
  getCOSToken() {
    //axios请求获取cos临时密钥
    if (!window.$VUE.$store.state.user) {
      return new Error("用户未登录");
    }
    //如果有超时时间且还有5分钟以上则不用获取token
    if (window.$VUE.__COSExpiredTime && window.$VUE.__COSExpiredTime * 1000 - new Date().getTime() > 5 * 60 * 1000) {
      console.log("cos token未过期");
      return Promise.resolve();
    } else {
      return window.$VUE.$axios
        .post("/getTCToken", {
          user: window.$VUE.$store.state.user.id,
        })
        .then((res) => {
          if (res.data.success) {
            const cos = new COS({
              SecretId: res.data.data.credentials.tmpSecretId, // 推荐使用环境变量获取；用户的 SecretId，建议使用子账号密钥，授权遵循最小权限指引，降低使用风险。子账号密钥获取可参考https://cloud.tencent.com/document/product/598/37140
              SecretKey: res.data.data.credentials.tmpSecretKey, // 推荐使用环境变量获取；用户的 SecretKey，建议使用子账号密钥，授权遵循最小权限指引，降低使用风险。子账号密钥获取可参考https://cloud.tencent.com/document/product/598/37140
              SecurityToken: res.data.data.credentials.sessionToken, // sts服务下发的临时 SessionToken
              StartTime: res.data.data.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
              ExpiredTime: res.data.data.expiredTime, // 临时密钥过期时间
            });
            window.$VUE.$COS = cos;
            window.$VUE.__COSExpiredTime = res.data.data.expiredTime; //记录过期时间
          } else {
            return new Error("获取cos临时密钥失败");
          }
        })
        .catch((err) => {
          console.log("getCOSToken", err);
          window.$VUE.$method.message(err.message);
          throw new Error(err.message);
        });
    }
  },
  uploadToCOS({ file, group, onProgress }) {
    return new Promise((resolve, reject) => {
      //从file.name中提取文件后缀名
      let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      let uploadTaskId = null;
      window.$VUE.$COS.uploadFile(
        {
          Bucket: "dreamrail-1255627425", // 填入您自己的存储桶，必须字段
          Region: "ap-shanghai", // 存储桶所在地域，例如ap-beijing，必须字段
          Key: `${group}/${new Date().format("yyyy-MM-dd")}/${window.$VUE.$store.state.user.id}/${new Date().getTime()}.${suffix}`, // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
          Body: file, // 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象
          SliceSize: 1024 * 1024 * 5, // 触发分块上传的阈值，超过5MB使用分块上传，非必须
          onTaskReady: (taskId) => {
            // 非必须
            console.log(taskId);
            uploadTaskId = taskId;
          },
          onProgress: (progressData) => {
            // 非必须
            console.log(progressData);
            if (typeof onProgress === "function") {
              onProgress(progressData, uploadTaskId);
            }
          },
        },
        (err, data) => {
          if (err) {
            console.log("上传失败", err);
            reject(err);
          } else {
            console.log("上传成功", data);
            resolve(
              Object.assign({}, data, {
                url: data.Location.replace("file2.dreamrail.cn", "https://file2.dreamrail.cn").replace("dreamrail-1255627425.cos.ap-shanghai.myqcloud.com", "https://file2.dreamrail.cn"),
              })
            );
          }
        }
      );
    });
  },
  delUrlParam(param) {
    let obj = new window.URL(window.location.href);
    obj.searchParams.delete(param);
    return obj.href;
  },
  //增加url中的参数
  addUrlParam(key, value) {
    let obj = new window.URL(window.location.href);
    obj.searchParams.set(key, value);
    return obj.href;
  },
  compressImg(file, quality) {
    var qualitys = 0.52;
    console.log(parseInt((file.size / 1024).toFixed(2)));
    if (parseInt((file.size / 1024).toFixed(2)) < 1024) {
      qualitys = 0.85;
    }
    if (5 * 1024 < parseInt((file.size / 1024).toFixed(2))) {
      qualitys = 0.92;
    }
    if (quality) {
      qualitys = quality;
    }
    if (file[0]) {
      return Promise.all(Array.from(file).map((e) => this.compressImg(e, qualitys))); // 如果是 file 数组返回 Promise 数组
    } else {
      return new Promise((resolve) => {
        console.log(file);
        if ((file.size / 1024).toFixed(2) < 300) {
          resolve({
            file: file,
          });
        } else {
          const reader = new FileReader(); // 创建 FileReader
          reader.onload = ({ target: { result: src } }) => {
            const image = new Image(); // 创建 img 元素
            image.onload = async () => {
              const canvas = document.createElement("canvas"); // 创建 canvas 元素
              const context = canvas.getContext("2d");
              var targetWidth = image.width;
              var targetHeight = image.height;
              var originWidth = image.width;
              var originHeight = image.height;
              if (1 * 1024 <= parseInt((file.size / 1024).toFixed(2)) && parseInt((file.size / 1024).toFixed(2)) <= 10 * 1024) {
                var maxWidth = 1600;
                var maxHeight = 1600;
                targetWidth = originWidth;
                targetHeight = originHeight;
                // 图片尺寸超过的限制
                if (originWidth > maxWidth || originHeight > maxHeight) {
                  if (originWidth / originHeight > maxWidth / maxHeight) {
                    // 更宽，按照宽度限定尺寸
                    targetWidth = maxWidth;
                    targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                  } else {
                    targetHeight = maxHeight;
                    targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                  }
                }
              }
              if (10 * 1024 <= parseInt((file.size / 1024).toFixed(2)) && parseInt((file.size / 1024).toFixed(2)) <= 20 * 1024) {
                maxWidth = 1400;
                maxHeight = 1400;
                targetWidth = originWidth;
                targetHeight = originHeight;
                // 图片尺寸超过的限制
                if (originWidth > maxWidth || originHeight > maxHeight) {
                  if (originWidth / originHeight > maxWidth / maxHeight) {
                    // 更宽，按照宽度限定尺寸
                    targetWidth = maxWidth;
                    targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                  } else {
                    targetHeight = maxHeight;
                    targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                  }
                }
              }
              canvas.width = targetWidth;
              canvas.height = targetHeight;
              context.clearRect(0, 0, targetWidth, targetHeight);
              context.drawImage(image, 0, 0, targetWidth, targetHeight); // 绘制 canvas
              const canvasURL = canvas.toDataURL("image/jpeg", qualitys);
              const buffer = atob(canvasURL.split(",")[1]);
              let length = buffer.length;
              const bufferArray = new Uint8Array(new ArrayBuffer(length));
              while (length--) {
                bufferArray[length] = buffer.charCodeAt(length);
              }
              const miniFile = new File([bufferArray], file.name, {
                type: "image/jpeg",
              });
              console.log({
                file: miniFile,
                origin: file,
                beforeSrc: src,
                afterSrc: canvasURL,
                beforeKB: Number((file.size / 1024).toFixed(2)),
                afterKB: Number((miniFile.size / 1024).toFixed(2)),
                qualitys: qualitys,
              });
              resolve({
                file: miniFile,
                origin: file,
                beforeSrc: src,
                afterSrc: canvasURL,
                beforeKB: Number((file.size / 1024).toFixed(2)),
                afterKB: Number((miniFile.size / 1024).toFixed(2)),
              });
            };
            image.src = src;
          };
          reader.readAsDataURL(file);
        }
      });
    }
  },
};
